export const IMPORT_PENDING = null;
export const IMPORTING = 1;
export const IMPORTED = 2;
export const MANUALLY_IMPORTED = 3;
export const IMPORT_ERROR = 4;
